import { Role as RoleEntity } from '../graphql/entities/role';
import { Role } from '../graphql/entities/role/enum';

const verifyPermission = (rolesPermitted: Role[], roles: RoleEntity[]) => {
  return roles.some(r => rolesPermitted.includes(r.name));
};

export default verifyPermission;
